import React from 'react'
import ListCreatedVirtualClassrooms from '../common'

const ListTodayPage = () => <ListCreatedVirtualClassrooms type="today" />

export default ListTodayPage
